import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getFranceCitiesByDepartmentList(department: string) {
  return restApiClient
    .url(
      encodeNestedObject(constructApiUrl(API.countries.getFranceCitiesByDepartment.url, null), {
        department
      })
    )
    .get<string[]>()
}
